// Сгенерировано frontend/scripts/export-game-assets.mjs — не править руками.
import fox from './fox.webp';
import icons from './icons.webp';
import family from './family.webp';
import foxFaces from './fox-faces.webp';
import items from './items.webp';
import cafeItems from './cafe-items.webp';
import planeSeated from './plane-seated.webp';
import planeSeatedSide from './plane-seated-side.webp';
import planeWideFoxSeat from './plane-wide-fox-seat.webp';
import grammoBust from './grammo-bust.webp';
import grammoBlink from './grammo-blink.webp';
import grammoPeek from './grammo-peek.webp';
import grammoJars from './grammo-jars.webp';
import grammoBustNohat from './grammo-bust-nohat.webp';
import grammoHats from './grammo-hats.webp';
import kaiStates from './kai-states.webp';
import kaiPortraits from './kai-portraits.webp';
import kaiFaces from './kai-faces.webp';
import kaiBust from './kai-bust.webp';
import kaiBlink from './kai-blink.webp';
import samStates from './sam-states.webp';
import samPortraits from './sam-portraits.webp';
import samFaces from './sam-faces.webp';
import samBust from './sam-bust.webp';
import samBlink from './sam-blink.webp';
import miaStates from './mia-states.webp';
import miaPortraits from './mia-portraits.webp';
import miaFaces from './mia-faces.webp';
import miaBust from './mia-bust.webp';
import miaBlink from './mia-blink.webp';
import arthurStates from './arthur-states.webp';
import arthurPortraits from './arthur-portraits.webp';
import arthurFaces from './arthur-faces.webp';
import arthurBust from './arthur-bust.webp';
import arthurBlink from './arthur-blink.webp';
import ollyStates from './olly-states.webp';
import ollyPortraits from './olly-portraits.webp';
import ollyFaces from './olly-faces.webp';
import ollyBust from './olly-bust.webp';
import ollyBlink from './olly-blink.webp';
import officerStates from './officer-states.webp';
import officerPortraits from './officer-portraits.webp';
import officerFaces from './officer-faces.webp';
import officerBust from './officer-bust.webp';
import officerBlink from './officer-blink.webp';
import noraStates from './nora-states.webp';
import noraPortraits from './nora-portraits.webp';
import noraFaces from './nora-faces.webp';
import noraBust from './nora-bust.webp';
import noraBlink from './nora-blink.webp';
import jadeBust from './jade-bust.webp';
import jadeBlink from './jade-blink.webp';
import patelBust from './patel-bust.webp';
import patelBlink from './patel-blink.webp';
import graceBust from './grace-bust.webp';
import graceBlink from './grace-blink.webp';
import lucyBust from './lucy-bust.webp';
import lucyBlink from './lucy-blink.webp';
import marcoBust from './marco-bust.webp';
import marcoBlink from './marco-blink.webp';
import zoeBust from './zoe-bust.webp';
import zoeBlink from './zoe-blink.webp';
import benBust from './ben-bust.webp';
import benBlink from './ben-blink.webp';
import walkerWoman from './walker-woman.webp';
import walkerMan from './walker-man.webp';
import walkerHood from './walker-hood.webp';
import street from './street.webp';
import streetWide from './street-wide.webp';
import map from './map.webp';
import hostelTall from './hostel-tall.webp';
import hostelWide from './hostel-wide.webp';
import cafeTall from './cafe-tall.webp';
import cafeWide from './cafe-wide.webp';
import chippyTall from './chippy-tall.webp';
import chippyWide from './chippy-wide.webp';
import streetDayTall from './street-day-tall.webp';
import streetDayWide from './street-day-wide.webp';
import planeTall from './plane-tall.webp';
import planeWide from './plane-wide.webp';
import planeWidePeople from './plane-wide-people.webp';
import passportTall from './passport-tall.webp';
import passportWide from './passport-wide.webp';
import tubeTall from './tube-tall.webp';
import tubeWide from './tube-wide.webp';
import dlgHostelTall from './dlg-hostel-tall.webp';
import dlgHostelWide from './dlg-hostel-wide.webp';
import dlgCafeTall from './dlg-cafe-tall.webp';
import dlgCafeWide from './dlg-cafe-wide.webp';
import dlgChippyTall from './dlg-chippy-tall.webp';
import dlgChippyWide from './dlg-chippy-wide.webp';
import dlgParkTall from './dlg-park-tall.webp';
import dlgParkWide from './dlg-park-wide.webp';
import dlgStreetTall from './dlg-street-tall.webp';
import dlgStreetWide from './dlg-street-wide.webp';
import dlgPlaneTall from './dlg-plane-tall.webp';
import dlgPlaneWide from './dlg-plane-wide.webp';
import dlgPassportTall from './dlg-passport-tall.webp';
import dlgPassportWide from './dlg-passport-wide.webp';
import dlgInfodeskTall from './dlg-infodesk-tall.webp';
import dlgInfodeskWide from './dlg-infodesk-wide.webp';
import dlgArenaTall from './dlg-arena-tall.webp';
import dlgArenaWide from './dlg-arena-wide.webp';
import dlgM_bikeTall from './dlg-m_bike-tall.webp';
import dlgM_bikeWide from './dlg-m_bike-wide.webp';
import dlgM_checkinTall from './dlg-m_checkin-tall.webp';
import dlgM_checkinWide from './dlg-m_checkin-wide.webp';
import dlgM_coldTall from './dlg-m_cold-tall.webp';
import dlgM_coldWide from './dlg-m_cold-wide.webp';
import dlgM_noiseTall from './dlg-m_noise-tall.webp';
import dlgM_noiseWide from './dlg-m_noise-wide.webp';
import dlgM_punctureTall from './dlg-m_puncture-tall.webp';
import dlgM_punctureWide from './dlg-m_puncture-wide.webp';
import dlgM_sweaterTall from './dlg-m_sweater-tall.webp';
import dlgM_sweaterWide from './dlg-m_sweater-wide.webp';
import dlgM_tableTall from './dlg-m_table-tall.webp';
import dlgM_tableWide from './dlg-m_table-wide.webp';
import dlgM_ticketTall from './dlg-m_ticket-tall.webp';
import dlgM_ticketWide from './dlg-m_ticket-wide.webp';
import homeBg from './home-bg.webp';
import homeSceneStart from './home-scene-start.webp';
import homeSceneHappy from './home-scene-happy.webp';
import homeSceneMessages from './home-scene-messages.webp';
import homeSceneHungry from './home-scene-hungry.webp';
import homeSceneTired from './home-scene-tired.webp';
import homeFoxStart from './home-fox-start.webp';
import homeFoxHappy from './home-fox-happy.webp';
import homeFoxMessages from './home-fox-messages.webp';
import homeFoxHungry from './home-fox-hungry.webp';
import homeFoxTired from './home-fox-tired.webp';
import life1 from './life-1.webp';
import life2 from './life-2.webp';
import life3 from './life-3.webp';
import life4 from './life-4.webp';
import life5 from './life-5.webp';
import life6 from './life-6.webp';
import life7 from './life-7.webp';
import life8 from './life-8.webp';
import life9 from './life-9.webp';
import life10 from './life-10.webp';
import life11 from './life-11.webp';
import life12 from './life-12.webp';
import album1 from './album-1.webp';
import album2 from './album-2.webp';
import album3 from './album-3.webp';
import album4 from './album-4.webp';
import album5 from './album-5.webp';
import album6 from './album-6.webp';
import flashback1 from './flashback-1.webp';
import flashback2 from './flashback-2.webp';

/**
 * blink — у листа по пояс: прямоугольник [x, y, w, h] в пикселях ячейки, куда накладывается ячейка i листа
 * `<id>-blink` (закрытые глаза кадра i, вне век прозрачно); blinkOk[i] — у кадра i можно моргать (проверено глазами).
 */
export type ArtSheet = {
  url: string;
  w: number;
  h: number;
  cell?: [number, number];
  cols?: number;
  rows?: number;
  blink?: [number, number, number, number];
  blinkOk?: boolean[];
  /** Цикл ходьбы (`walker-*`): кадров по строкам, рекомендуемый темп и сколько тело проходит за полный круг кадров, в долях высоты ячейки. */
  frames?: number;
  fps?: number;
  stride?: number;
};

export const ART: Record<string, ArtSheet> = {
  'fox': { url: fox, w: 720, h: 916, cell: [180, 229], cols: 4, rows: 4 },
  'icons': { url: icons, w: 652, h: 330, cell: [163, 165], cols: 4, rows: 2 },
  'family': { url: family, w: 402, h: 456, cell: [134, 152], cols: 3, rows: 3 },
  'fox-faces': { url: foxFaces, w: 441, h: 356, cell: [147, 178], cols: 3, rows: 2 },
  'items': { url: items, w: 688, h: 342, cell: [172, 171], cols: 4, rows: 2 },
  'cafe-items': { url: cafeItems, w: 608, h: 435, cell: [152, 145], cols: 4, rows: 3 },
  'plane-seated': { url: planeSeated, w: 896, h: 656, cell: [224, 328], cols: 4, rows: 2 },
  'plane-seated-side': { url: planeSeatedSide, w: 1268, h: 646, cell: [317, 323], cols: 4, rows: 2 },
  'plane-wide-fox-seat': { url: planeWideFoxSeat, w: 96, h: 144, cell: [96, 144], cols: 1, rows: 1 },
  'grammo-bust': { url: grammoBust, w: 2517, h: 4095, cell: [839, 1365], cols: 3, rows: 3, blink: [330, 455, 311, 146], blinkOk: [true, true, false, false, false, false, false, false] },
  'grammo-blink': { url: grammoBlink, w: 933, h: 438, cell: [311, 146], cols: 3, rows: 3 },
  'grammo-peek': { url: grammoPeek, w: 910, h: 739, cell: [455, 739], cols: 2, rows: 1 },
  'grammo-jars': { url: grammoJars, w: 968, h: 308, cell: [242, 308], cols: 4, rows: 1 },
  'grammo-bust-nohat': { url: grammoBustNohat, w: 2517, h: 4095, cell: [839, 1365], cols: 3, rows: 3, blink: [330, 455, 311, 146], blinkOk: [true, true, false, false, false, false, false, false] },
  'grammo-hats': { url: grammoHats, w: 2880, h: 1440, cell: [720, 720], cols: 4, rows: 2 },
  'kai-states': { url: kaiStates, w: 664, h: 608, cell: [166, 304], cols: 4, rows: 2 },
  'kai-portraits': { url: kaiPortraits, w: 618, h: 224, cell: [206, 224], cols: 3, rows: 1 },
  'kai-faces': { url: kaiFaces, w: 534, h: 406, cell: [178, 203], cols: 3, rows: 2 },
  'kai-bust': { url: kaiBust, w: 2406, h: 2590, cell: [802, 1295], cols: 3, rows: 2, blink: [304, 154, 259, 84], blinkOk: [true, false, true, true, true, false] },
  'kai-blink': { url: kaiBlink, w: 777, h: 168, cell: [259, 84], cols: 3, rows: 2 },
  'sam-states': { url: samStates, w: 576, h: 580, cell: [144, 290], cols: 4, rows: 2 },
  'sam-portraits': { url: samPortraits, w: 564, h: 225, cell: [188, 225], cols: 3, rows: 1 },
  'sam-faces': { url: samFaces, w: 495, h: 402, cell: [165, 201], cols: 3, rows: 2 },
  'sam-bust': { url: samBust, w: 2121, h: 2568, cell: [707, 1284], cols: 3, rows: 2, blink: [228, 174, 316, 119], blinkOk: [true, false, true, true, true, false] },
  'sam-blink': { url: samBlink, w: 948, h: 238, cell: [316, 119], cols: 3, rows: 2 },
  'mia-states': { url: miaStates, w: 676, h: 580, cell: [169, 290], cols: 4, rows: 2 },
  'mia-portraits': { url: miaPortraits, w: 531, h: 220, cell: [177, 220], cols: 3, rows: 1 },
  'mia-faces': { url: miaFaces, w: 468, h: 398, cell: [156, 199], cols: 3, rows: 2 },
  'mia-bust': { url: miaBust, w: 1995, h: 2590, cell: [665, 1295], cols: 3, rows: 2, blink: [177, 188, 389, 123], blinkOk: [true, true, true, true, true, false] },
  'mia-blink': { url: miaBlink, w: 1167, h: 246, cell: [389, 123], cols: 3, rows: 2 },
  'arthur-states': { url: arthurStates, w: 688, h: 546, cell: [172, 273], cols: 4, rows: 2 },
  'arthur-portraits': { url: arthurPortraits, w: 612, h: 220, cell: [204, 220], cols: 3, rows: 1 },
  'arthur-faces': { url: arthurFaces, w: 579, h: 406, cell: [193, 203], cols: 3, rows: 2 },
  'arthur-bust': { url: arthurBust, w: 2565, h: 2600, cell: [855, 1300], cols: 3, rows: 2, blink: [317, 242, 280, 54], blinkOk: [true, false, true, true, false, false] },
  'arthur-blink': { url: arthurBlink, w: 840, h: 108, cell: [280, 54], cols: 3, rows: 2 },
  'olly-states': { url: ollyStates, w: 888, h: 702, cell: [222, 351], cols: 4, rows: 2 },
  'olly-portraits': { url: ollyPortraits, w: 600, h: 223, cell: [200, 223], cols: 3, rows: 1 },
  'olly-faces': { url: ollyFaces, w: 564, h: 406, cell: [188, 203], cols: 3, rows: 2 },
  'olly-bust': { url: ollyBust, w: 2601, h: 2600, cell: [867, 1300], cols: 3, rows: 2, blink: [303, 263, 290, 115], blinkOk: [true, false, true, true, true, false] },
  'olly-blink': { url: ollyBlink, w: 870, h: 230, cell: [290, 115], cols: 3, rows: 2 },
  'officer-states': { url: officerStates, w: 688, h: 682, cell: [172, 341], cols: 4, rows: 2 },
  'officer-portraits': { url: officerPortraits, w: 570, h: 222, cell: [190, 222], cols: 3, rows: 1 },
  'officer-faces': { url: officerFaces, w: 513, h: 404, cell: [171, 202], cols: 3, rows: 2 },
  'officer-bust': { url: officerBust, w: 2160, h: 2600, cell: [720, 1300], cols: 3, rows: 2, blink: [247, 191, 275, 99], blinkOk: [true, true, true, true, true, false] },
  'officer-blink': { url: officerBlink, w: 825, h: 198, cell: [275, 99], cols: 3, rows: 2 },
  'nora-states': { url: noraStates, w: 780, h: 700, cell: [195, 350], cols: 4, rows: 2 },
  'nora-portraits': { url: noraPortraits, w: 543, h: 220, cell: [181, 220], cols: 3, rows: 1 },
  'nora-faces': { url: noraFaces, w: 489, h: 392, cell: [163, 196], cols: 3, rows: 2 },
  'nora-bust': { url: noraBust, w: 2433, h: 2600, cell: [811, 1300], cols: 3, rows: 2, blink: [267, 180, 363, 132], blinkOk: [true, true, true, true, true, false] },
  'nora-blink': { url: noraBlink, w: 1089, h: 264, cell: [363, 132], cols: 3, rows: 2 },
  'jade-bust': { url: jadeBust, w: 2487, h: 2592, cell: [829, 1296], cols: 3, rows: 2, blink: [303, 236, 292, 115], blinkOk: [true, false, false, false, false, false] },
  'jade-blink': { url: jadeBlink, w: 876, h: 230, cell: [292, 115], cols: 3, rows: 2 },
  'patel-bust': { url: patelBust, w: 2577, h: 2590, cell: [859, 1295], cols: 3, rows: 2, blink: [278, 150, 286, 86], blinkOk: [true, false, false, false, false, false] },
  'patel-blink': { url: patelBlink, w: 858, h: 172, cell: [286, 86], cols: 3, rows: 2 },
  'grace-bust': { url: graceBust, w: 2394, h: 2590, cell: [798, 1295], cols: 3, rows: 2, blink: [305, 212, 295, 90], blinkOk: [true, false, false, false, false, false] },
  'grace-blink': { url: graceBlink, w: 885, h: 180, cell: [295, 90], cols: 3, rows: 2 },
  'lucy-bust': { url: lucyBust, w: 2364, h: 2592, cell: [788, 1296], cols: 3, rows: 2, blink: [279, 187, 290, 98], blinkOk: [true, false, false, false, false, false] },
  'lucy-blink': { url: lucyBlink, w: 870, h: 196, cell: [290, 98], cols: 3, rows: 2 },
  'marco-bust': { url: marcoBust, w: 2544, h: 2592, cell: [848, 1296], cols: 3, rows: 2, blink: [325, 156, 238, 82], blinkOk: [true, false, false, false, false, false] },
  'marco-blink': { url: marcoBlink, w: 714, h: 164, cell: [238, 82], cols: 3, rows: 2 },
  'zoe-bust': { url: zoeBust, w: 2589, h: 2594, cell: [863, 1297], cols: 3, rows: 2, blink: [335, 264, 290, 113], blinkOk: [true, false, false, false, false, false] },
  'zoe-blink': { url: zoeBlink, w: 870, h: 226, cell: [290, 113], cols: 3, rows: 2 },
  'ben-bust': { url: benBust, w: 2502, h: 2600, cell: [834, 1300], cols: 3, rows: 2, blink: [348, 172, 163, 69], blinkOk: [true, false, false, false, false, false] },
  'ben-blink': { url: benBlink, w: 489, h: 138, cell: [163, 69], cols: 3, rows: 2 },
  'walker-woman': { url: walkerWoman, w: 728, h: 600, cell: [182, 300], cols: 4, rows: 2, frames: 8, fps: 10, stride: 0.768 },
  'walker-man': { url: walkerMan, w: 712, h: 600, cell: [178, 300], cols: 4, rows: 2, frames: 8, fps: 10, stride: 0.721 },
  'walker-hood': { url: walkerHood, w: 700, h: 600, cell: [175, 300], cols: 4, rows: 2, frames: 8, fps: 10, stride: 0.816 },
  'street': { url: street, w: 941, h: 1672 },
  'street-wide': { url: streetWide, w: 1672, h: 941 },
  'map': { url: map, w: 1254, h: 1254 },
  'hostel-tall': { url: hostelTall, w: 941, h: 1672 },
  'hostel-wide': { url: hostelWide, w: 1672, h: 941 },
  'cafe-tall': { url: cafeTall, w: 941, h: 1672 },
  'cafe-wide': { url: cafeWide, w: 1672, h: 941 },
  'chippy-tall': { url: chippyTall, w: 941, h: 1672 },
  'chippy-wide': { url: chippyWide, w: 1672, h: 941 },
  'street-day-tall': { url: streetDayTall, w: 941, h: 1672 },
  'street-day-wide': { url: streetDayWide, w: 1672, h: 941 },
  'plane-tall': { url: planeTall, w: 941, h: 1672 },
  'plane-wide': { url: planeWide, w: 1672, h: 941 },
  'plane-wide-people': { url: planeWidePeople, w: 1672, h: 941 },
  'passport-tall': { url: passportTall, w: 941, h: 1672 },
  'passport-wide': { url: passportWide, w: 1672, h: 941 },
  'tube-tall': { url: tubeTall, w: 941, h: 1672 },
  'tube-wide': { url: tubeWide, w: 1672, h: 941 },
  'dlg-hostel-tall': { url: dlgHostelTall, w: 941, h: 1672 },
  'dlg-hostel-wide': { url: dlgHostelWide, w: 1672, h: 941 },
  'dlg-cafe-tall': { url: dlgCafeTall, w: 941, h: 1672 },
  'dlg-cafe-wide': { url: dlgCafeWide, w: 1672, h: 941 },
  'dlg-chippy-tall': { url: dlgChippyTall, w: 941, h: 1672 },
  'dlg-chippy-wide': { url: dlgChippyWide, w: 1672, h: 941 },
  'dlg-park-tall': { url: dlgParkTall, w: 941, h: 1672 },
  'dlg-park-wide': { url: dlgParkWide, w: 1672, h: 941 },
  'dlg-street-tall': { url: dlgStreetTall, w: 941, h: 1672 },
  'dlg-street-wide': { url: dlgStreetWide, w: 1672, h: 941 },
  'dlg-plane-tall': { url: dlgPlaneTall, w: 941, h: 1672 },
  'dlg-plane-wide': { url: dlgPlaneWide, w: 1672, h: 941 },
  'dlg-passport-tall': { url: dlgPassportTall, w: 941, h: 1672 },
  'dlg-passport-wide': { url: dlgPassportWide, w: 1672, h: 941 },
  'dlg-infodesk-tall': { url: dlgInfodeskTall, w: 941, h: 1672 },
  'dlg-infodesk-wide': { url: dlgInfodeskWide, w: 1672, h: 941 },
  'dlg-arena-tall': { url: dlgArenaTall, w: 941, h: 1672 },
  'dlg-arena-wide': { url: dlgArenaWide, w: 1672, h: 941 },
  'dlg-m_bike-tall': { url: dlgM_bikeTall, w: 941, h: 1672 },
  'dlg-m_bike-wide': { url: dlgM_bikeWide, w: 1672, h: 941 },
  'dlg-m_checkin-tall': { url: dlgM_checkinTall, w: 941, h: 1672 },
  'dlg-m_checkin-wide': { url: dlgM_checkinWide, w: 1672, h: 941 },
  'dlg-m_cold-tall': { url: dlgM_coldTall, w: 941, h: 1672 },
  'dlg-m_cold-wide': { url: dlgM_coldWide, w: 1672, h: 941 },
  'dlg-m_noise-tall': { url: dlgM_noiseTall, w: 941, h: 1671 },
  'dlg-m_noise-wide': { url: dlgM_noiseWide, w: 1672, h: 941 },
  'dlg-m_puncture-tall': { url: dlgM_punctureTall, w: 941, h: 1672 },
  'dlg-m_puncture-wide': { url: dlgM_punctureWide, w: 1672, h: 941 },
  'dlg-m_sweater-tall': { url: dlgM_sweaterTall, w: 941, h: 1672 },
  'dlg-m_sweater-wide': { url: dlgM_sweaterWide, w: 1672, h: 941 },
  'dlg-m_table-tall': { url: dlgM_tableTall, w: 941, h: 1671 },
  'dlg-m_table-wide': { url: dlgM_tableWide, w: 1672, h: 941 },
  'dlg-m_ticket-tall': { url: dlgM_ticketTall, w: 941, h: 1671 },
  'dlg-m_ticket-wide': { url: dlgM_ticketWide, w: 1672, h: 941 },
  'home-bg': { url: homeBg, w: 2400, h: 800 },
  'home-scene-start': { url: homeSceneStart, w: 2400, h: 800 },
  'home-scene-happy': { url: homeSceneHappy, w: 2400, h: 800 },
  'home-scene-messages': { url: homeSceneMessages, w: 2400, h: 800 },
  'home-scene-hungry': { url: homeSceneHungry, w: 2400, h: 800 },
  'home-scene-tired': { url: homeSceneTired, w: 2400, h: 800 },
  'home-fox-start': { url: homeFoxStart, w: 480, h: 600 },
  'home-fox-happy': { url: homeFoxHappy, w: 480, h: 600 },
  'home-fox-messages': { url: homeFoxMessages, w: 480, h: 600 },
  'home-fox-hungry': { url: homeFoxHungry, w: 480, h: 600 },
  'home-fox-tired': { url: homeFoxTired, w: 480, h: 600 },
  'life-1': { url: life1, w: 230, h: 158 },
  'life-2': { url: life2, w: 223, h: 132 },
  'life-3': { url: life3, w: 216, h: 107 },
  'life-4': { url: life4, w: 200, h: 202 },
  'life-5': { url: life5, w: 148, h: 244 },
  'life-6': { url: life6, w: 147, h: 244 },
  'life-7': { url: life7, w: 148, h: 244 },
  'life-8': { url: life8, w: 147, h: 242 },
  'life-9': { url: life9, w: 102, h: 95 },
  'life-10': { url: life10, w: 119, h: 58 },
  'life-11': { url: life11, w: 110, h: 128 },
  'life-12': { url: life12, w: 174, h: 108 },
  'album-1': { url: album1, w: 400, h: 400 },
  'album-2': { url: album2, w: 400, h: 400 },
  'album-3': { url: album3, w: 400, h: 400 },
  'album-4': { url: album4, w: 400, h: 400 },
  'album-5': { url: album5, w: 400, h: 400 },
  'album-6': { url: album6, w: 400, h: 400 },
  'flashback-1': { url: flashback1, w: 605, h: 810 },
  'flashback-2': { url: flashback2, w: 605, h: 810 },
};

/** Вес всех картинок, байт, — для полосы загрузки. */
export const ART_BYTES = 31249414;
